export default "__VITE_ASSET__91f427cc__"